import { render } from "./Pagination.vue?vue&type=template&id=24008c4e&scoped=true"
import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=24008c4e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24008c4e"],['__file',"src/pages/components/parts/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24008c4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24008c4e', __exports__)) {
    console.log('reload')
    api.reload('24008c4e', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=24008c4e&scoped=true", () => {
    console.log('re-render')
    api.rerender('24008c4e', render)
  })

}


export default __exports__